'use client';

import { useEffect } from 'react';
import { useAnalytics, type AnalyticsListing } from '@contexts/use-analytics';

interface SerpClientEnhancementsProps {
  regionDataEntries: AnalyticsListing[];
}

/**
 * Client-side enhancements for the SERP page.
 * Handles analytics tracking for listings displayed on the page.
 * This component renders nothing visible - it's purely for side effects.
 */
export function SerpClientEnhancements({
  regionDataEntries,
}: SerpClientEnhancementsProps) {
  const { setListings } = useAnalytics();

  useEffect(() => {
    // Track listings for analytics when the page loads
    setListings('serp', regionDataEntries);
  }, [regionDataEntries, setListings]);

  // This component renders nothing - it's purely for side effects
  return null;
}
